import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { watchRequestReservation } from 'features/Reservation/Reservation.saga';
import { withSagas } from 'decorators/Sagas';
import { decorateWith } from 'helpers/decorator';
import { selectIsClient, selectIsMobile, selectMediaState } from 'redux/modules/device';
import { isLoggedIn, setScheduleContext } from 'redux/modules/user';
import { FullHeight } from 'decorators/FullHeight/FullHeight';
import { Search } from './Search';
import { selectDataFromResultsLayout, selectMetadataInLayout } from './Search.helpers';
import { selectMapView, selectIsMapToggleable } from './Search.reducer';
import { selectOpenPanel } from './SearchBox/SearchBox.reducer';
import { watchFilters } from './filters/filters.saga';
import { selectResultType } from './filters/filters.helpers';
import { watchInteractions } from './filters/interactions.saga';
import { loadSearch, watchSearch } from './search.saga';

export const mapStateToProps = state => {
  const resultType = selectResultType(state);
  const mediaState = selectMediaState(state);
  const isClient = selectIsClient(state);
  const includeSearchBox = isClient && !mediaState.lg;
  const resultsFromLayout = selectDataFromResultsLayout(state);
  const filterMetadata = selectMetadataInLayout(resultsFromLayout);

  return {
    hasStackedSearchBoxes: !!selectOpenPanel(state),
    isMapView: selectMapView(state),
    isMobile: selectIsMobile(state),
    isMapToggleable: selectIsMapToggleable(state),
    isLoggedIn: isLoggedIn(state),
    resultType,
    includeSearchBox,
    filterMetadata,
  };
};

const mapDispatchToProps = {
  setScheduleContext,
};

export const SearchContainer = decorateWith(
  FullHeight,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withSagas({
    watch: [watchSearch, watchRequestReservation, watchFilters, watchInteractions],
    load: [loadSearch],
  })
)(Search);

export default SearchContainer;
